import Contrast from './src/contrast-combined';
export default Contrast;